import { DashboardContext } from '@/Contexts/DashboardContext';
import { ApplicationDataGridRowProps } from '@/models/Application';
import { UserType } from '@/models/User';
import { ApplicationStatus } from '@/utils/constants';

export function updateDashboardLists({
  updatedApp,
  dashboard,
  userType,
}: {
  updatedApp: ApplicationDataGridRowProps;
  dashboard: React.ContextType<typeof DashboardContext>;
  userType: UserType | null | undefined;
}) {
  const {
    currentApps,
    reviewApps,
    historicApps,
    updateCurrentApps,
    updateReviewApps,
    updateHistoricApps,
  } = dashboard;

  // Current
  {
    const next = [...currentApps];
    const idx = next.findIndex((x) => x.applicationId === updatedApp.applicationId);
    if (idx >= 0) {
      next[idx] = updatedApp;
      updateCurrentApps(next);
    }
  }

  // Historic
  {
    const next = [...historicApps];
    const idx = next.findIndex((x) => x.applicationId === updatedApp.applicationId);
    if (idx >= 0) {
      next[idx] = updatedApp;
      updateHistoricApps(next);
    }
  }

  // Review rules
  {
    const isReview =
      (userType === UserType.Adf && updatedApp.status === ApplicationStatus.PendingAdfReview) ||
      (userType === UserType.StateCoordinator &&
        updatedApp.status === ApplicationStatus.PendingStateReview);

    const next = [...reviewApps];
    const idx = next.findIndex((x) => x.applicationId === updatedApp.applicationId);

    if (isReview && idx >= 0) next[idx] = updatedApp;
    if (isReview && idx < 0) next.push(updatedApp);
    if (!isReview && idx >= 0) next.splice(idx, 1);

    updateReviewApps(next);
  }
}
